import * as e from "react";
import t from "../lib/IconBase.es.js";
import a from "../defs/User.es.js";
const o = e.forwardRef((r, s) => /* @__PURE__ */ e.createElement(t, { ref: s, ...r, weights: a }));
o.displayName = "UserIcon";
const n = o;
export {
  n as User,
  o as UserIcon
};
